import { PageNotAllowed, PageNotFound } from '@itz/react-cms-element';
import appConfigurationRoutes from '@modules/appConfiguration/routes';
import appManagementRoutes from '@modules/appManagement/routes';
import customerRoutes from '@modules/customer/routes';
import deviceManagerRoutes from '@modules/deviceManager/routes';
import deviceRequestRoutes from '@modules/deviceRequest/routes';
import digibesShopRoutes from '@modules/digibesShop/routes';
import Dashboard from '@modules/entry';
import GroupPermissionListPage from '@modules/groupPermission';
import PermissionSavePage from '@modules/groupPermission/PermissionSavePage';
import inwenRoutes from '@modules/inwen/routes';
import kitplayRequestRoutes from '@modules/kitplayRequest/routes';
import kitplayShopAccountRoutes from '@modules/kitplayShopAccount/routes';
import listKitPlayDeviceRoutes from '@modules/listKitplayDevice/routes';
import orderconRoutes from '@modules/listOrderconDevice/routes';
import orderDisplayRoutes from '@modules/listOrderDevice/routes';
import qrliveRoutes from '@modules/listQrliveDevice/routes';
import SettingListPage from '@modules/listSetting';
import SettingSavePage from '@modules/listSetting/SettingSavePage';
import LoginPage from '@modules/login/index';
import mediaRoutes from '@modules/media/routes';
import ProfilePage from '@modules/profile/index';
import restaurantExpiredRoutes from '@modules/restaurant/Expired/routes';
import restaurantRoutes from '@modules/restaurant/routes';
import serverProviderRoutes from '@modules/serverProvider/routes';
import shopAccountRoutes from '@modules/shopAccount/routes';
import adminsRoutes from '@modules/user/routes';
import VerifyPage from '@modules/verify';

import tenantRoutes from './tenantRoutes';
/*
    auth
        + null: access login and not login
        + true: access login only
        + false: access not login only
*/
const routes = {
    pageNotAllowed: {
        path: '/not-allowed',
        component: PageNotAllowed,
        auth: null,
        title: 'Page not allowed',
    },
    homePage: {
        path: '/',
        component: Dashboard,
        auth: true,
        title: 'Home',
    },
    settingPage: {
        path: '/setting',
        component: Dashboard,
        auth: true,
        title: 'Setting',
    },
    loginPage: {
        path: '/login',
        component: LoginPage,
        auth: false,
        title: 'Login page',
    },
    profilePage: {
        path: '/profile',
        component: ProfilePage,
        auth: true,
        title: 'Profile page',
    },
    groupPermissionPage: {
        path: '/group-permission',
        component: GroupPermissionListPage,
        auth: true,
        title: 'Profile page',
    },
    groupPermissionSavePage: {
        path: '/group-permission/:id',
        component: PermissionSavePage,
        auth: true,
        title: 'Profile page',
    },
    listSettingsPage: {
        path: '/settings',
        component: SettingListPage,
        auth: true,
        title: 'Settings page',
    },
    listSettingsPageSavePage: {
        path: '/settings/:id',
        component: SettingSavePage,
        auth: true,
        title: 'Settings page',
    },
    ...tenantRoutes,
    ...adminsRoutes,
    ...restaurantRoutes,
    ...shopAccountRoutes,
    ...customerRoutes,
    ...restaurantExpiredRoutes,
    ...inwenRoutes,
    ...deviceManagerRoutes,
    ...kitplayShopAccountRoutes,
    ...kitplayRequestRoutes,
    ...listKitPlayDeviceRoutes,
    ...digibesShopRoutes,
    ...appConfigurationRoutes,
    ...appManagementRoutes,
    ...orderDisplayRoutes,
    ...orderconRoutes,
    ...qrliveRoutes,
    ...deviceRequestRoutes,
    ...mediaRoutes,
    ...serverProviderRoutes,
    verify: {
        component: VerifyPage,
        auth: null,
        title: 'Verify',
        path: '/verify',
    },
    // keep this at last
    notFound: {
        component: PageNotFound,
        auth: null,
        title: 'Page not found',
        path: '*',
    },
};

export default routes;
